export const duration = (min, max) => {
  // console.log(min, max);
  if (max === null && min === null) {
    return "";
  } else if (min === 0) {
    return `(Hari ini)`;
  } else if (min === 0 && max === 1) {
    return `(Hari ini - Besok)`;
  } else if (max === null) {
    return `${min} hari`;
  } else if (min === null) {
    return `${max} hari`;
  } else if (min === max) {
    return `${min} hari`;
  } else if (min === 0) {
    return `(Hari ini)`;
  }

  return `${min} - ${max} hari`;
};
